import { Player } from "@lottiefiles/react-lottie-player";
import React, { Fragment } from "react";

const LottieFilePlayer = props => {
  const { lottieFile, style, loop } = props;

  return (
    <Fragment>
      <Player
        key={lottieFile}
        autoplay
        loop={loop}
        src={lottieFile}
        style={style}
      />
    </Fragment>
  );
};
export default LottieFilePlayer;
